import { EndpointBuilder } from "@reduxjs/toolkit/dist/query/endpointDefinitions";
import {
  BaseQueryFn,
  FetchArgs,
  FetchBaseQueryError,
  FetchBaseQueryMeta,
} from "@reduxjs/toolkit/dist/query";

import QueryTags from "api/types/QueryTags";
import TaskList from "api/types/models/task_list";

const TaskListEndpoints = (
  builder: EndpointBuilder<
    BaseQueryFn<
      string | FetchArgs,
      unknown,
      FetchBaseQueryError,
      {},
      FetchBaseQueryMeta
    >,
    QueryTags,
    "data"
  >,
) => ({
  getTaskLists: builder.query<{ [location_id: string]: TaskList[] }, void>({
    query: () => "/task-lists",
  }),
});

export default TaskListEndpoints;
